import { StatsAccumulator } from '#hub-stats';
// Lucid clients do use PUT and GET operations only. The hub uses LIST and DELETE ops as well.
var IoStatsType;
(function (IoStatsType) {
    IoStatsType[IoStatsType["PUT_SIZE"] = 0] = "PUT_SIZE";
    IoStatsType[IoStatsType["PUT_COUNT"] = 1] = "PUT_COUNT";
    IoStatsType[IoStatsType["GET_SIZE"] = 2] = "GET_SIZE";
    IoStatsType[IoStatsType["GET_COUNT"] = 3] = "GET_COUNT";
    IoStatsType[IoStatsType["HTTP_GET_SIZE"] = 7] = "HTTP_GET_SIZE";
    IoStatsType[IoStatsType["HTTP_GET_COUNT"] = 8] = "HTTP_GET_COUNT";
})(IoStatsType || (IoStatsType = {}));
var IoStatsSubType;
(function (IoStatsSubType) {
    IoStatsSubType[IoStatsSubType["HTTP_FILE"] = 0] = "HTTP_FILE";
})(IoStatsSubType || (IoStatsSubType = {}));
const NO_SUBTYPE_SENTINEL = 0xff;
function statIdOf(key) {
    return (key.type << 8) | (key.subType ?? NO_SUBTYPE_SENTINEL);
}
export class IoStats {
    nodeId;
    kvHelpers;
    accumulator;
    constructor(nodeId, kvHelpers, metaStore, tupleWasm, log, statsFlusher) {
        this.nodeId = nodeId;
        this.kvHelpers = kvHelpers;
        this.accumulator = new StatsAccumulator(this, metaStore, tupleWasm, log, 'io stats');
        this.setupIoStat('PUT_SIZE', { type: IoStatsType.PUT_SIZE });
        this.setupIoStat('PUT_COUNT', { type: IoStatsType.PUT_COUNT });
        this.setupIoStat('GET_SIZE', { type: IoStatsType.GET_SIZE });
        this.setupIoStat('GET_COUNT', { type: IoStatsType.GET_COUNT });
        this.setupIoStat('HTTP_GET_SIZE', { type: IoStatsType.HTTP_GET_SIZE });
        this.setupIoStat('HTTP_GET_COUNT', { type: IoStatsType.HTTP_GET_COUNT });
        this.setupIoStat('HTTP_FILE_GET_SIZE', { type: IoStatsType.HTTP_GET_SIZE, subType: IoStatsSubType.HTTP_FILE });
        this.setupIoStat('HTTP_FILE_GET_COUNT', {
            type: IoStatsType.HTTP_GET_COUNT,
            subType: IoStatsSubType.HTTP_FILE,
        });
        statsFlusher.register(this.accumulator);
    }
    incrementPutStats(putCount, putSize) {
        const putCountKey = { type: IoStatsType.PUT_COUNT };
        const putSizeKey = { type: IoStatsType.PUT_SIZE };
        this.incrementStatsFor(putCountKey, putCount, putSizeKey, putSize);
    }
    incrementGetStats(getCount, getSize) {
        const getCountKey = { type: IoStatsType.GET_COUNT };
        const getSizeKey = { type: IoStatsType.GET_SIZE };
        this.incrementStatsFor(getCountKey, getCount, getSizeKey, getSize);
    }
    incrementHttpGetStats(getCount, getSize) {
        const getCountKey = { type: IoStatsType.HTTP_GET_COUNT };
        const getSizeKey = { type: IoStatsType.HTTP_GET_SIZE };
        this.incrementStatsFor(getCountKey, getCount, getSizeKey, getSize);
    }
    incrementHttpFileGetStats(getCount, getSize) {
        const getCountKey = { type: IoStatsType.HTTP_GET_COUNT, subType: IoStatsSubType.HTTP_FILE };
        const getSizeKey = { type: IoStatsType.HTTP_GET_SIZE, subType: IoStatsSubType.HTTP_FILE };
        this.incrementStatsFor(getCountKey, getCount, getSizeKey, getSize);
    }
    toValue(value) {
        return this.kvHelpers.makeIoStatsValue(value);
    }
    getRange() {
        return this.kvHelpers.getIoStatsRange(this.nodeId);
    }
    toStatId(key) {
        const { type, subType } = this.kvHelpers.getIoStatsType(key);
        return statIdOf({ type, subType });
    }
    incrementStatsFor(countKey, count, sizeKey, size) {
        if (count > 0) {
            this.accumulator.increment(statIdOf(countKey), count);
        }
        if (size > 0) {
            this.accumulator.increment(statIdOf(sizeKey), size);
        }
    }
    setupIoStat(statName, statKey) {
        const key = this.kvHelpers.makeIoStatsKey(this.nodeId, statKey.type, statKey.subType);
        this.accumulator.setupStat(statIdOf(statKey), statName, key);
    }
}
